module.exports = __webpack_public_path__ + "static/media/waves_crashing_on_rocks.e5c9b782.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/waves_crashing_on_rocks.jpg
// module id = 265
// module chunks = 0